<template>

    <div v-show="showModel">
        <van-popup v-model="showModel" style="width: 100%" @click-overlay="close">
            <video :src="filePath" id="playVideos" autoplay controls class="upload-img">
                <source :src="filePath" type="video/mp4">
                    您的浏览器不支持Video标签。
            </video>
        </van-popup>
    </div>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        fileUrl: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            showModel: this.show,
            filePath: this.fileUrl
        }
    },
    methods: {
        close() {
            console.log('关闭')
            // this.$emit('close', false)
            this.$router.go(-1)
        },
        
    },
    watch: {
        show (newVal, oldVal) {
            console.log(newVal, oldVal)
            this.showModel = newVal
        },
        fileUrl (newVal, oldVal) {
            console.log(newVal, oldVal)
            this.filePath = newVal
            // this.$forceUpdate()
        }
    },
    created() {
        this.showModel = true;
        this.filePath = sessionStorage.getItem('videoUrl')
    }
}
</script>
<style scoped lang="less">
video {
    width: 100%;
}
</style>